import logo from './logo.svg';
import './App.css';
import { Navigate, Route, Routes, useNavigate, Redirect } from 'react-router-dom';
import { Cookies } from 'react-cookie';
import Home from './Components/Home/Home';
import NavbarComponent from './Components/NavBar/NavbarComponent';
import Settings from './Components/Settings/Settings';
import Summary from './Components/Summary/Summary';
import { useEffect, useState } from 'react';
import DataTable from 'datatables.net-autofill-bs5';
import DataTables from './Components/Summary/DataTables';
import Upload from './Components/Summary/Upload';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { SuccessUploadFile } from './Components/DialogMessage';
import data from './Users.json';
import summaryData from './Components/Summary/Data.json'
import ErrorPage from './Components/ErrorPage/ErrorPage';
import SettingUser from './Components/Settings/SettingUser';
import UploadAudio from './Components/Summary/UploadAudio';
import DraftSummary from './Components/DraftSummary/AudioGeneration/DraftSummary';
import Login from './Components/Authorization/Login';
import Register from './Components/Authorization/Register';
import PersistLogin from './Components/Authorization/PersistLogin';
import useLogout from './Components/hooks/useLogout';
import AuthMiddleware from './Components/Middleware/Auth';
import { axiosInstance } from './axios';
import Bearworld from './Components/Authorization/Bearworld';
import Instruction from './Components/instruction/Instruction';
import Presentation from './Components/presentation/Presentation';
import Joyride, { STATUS, ACTIONS } from 'react-joyride';

const steps = [
  {
    content: <h4>사용법을 확인하세요!</h4>,
    placement: 'bottom', // Adjust as needed based on your layout
    target: '.menu-item .fa-info-circle', // Targeting the specific icon
    // title: '가이드로 클릭하세요',
    disableBeacon: true,
    disableOverlayClose: true,
    hideCloseButton: true,
    hideFooter: true,
    spotlightClicks: true,
  }
];


function App() {
  const [showGuide, setShowGuide] = useState(false);


  const [dropdown, setDropdown] = useState(false);
  const [loading, setLoading] = useState(false);
  const logout = useLogout()
  const [userData, setUserData] = useState(null);
  const [closed, setClosed] = useState(false);

  const handleJoyrideCallback = (data) => {
    const { status } = data;
    const finishedStatuses = ['finished', 'skipped'];

    if (finishedStatuses.includes(status)) {
      setShowGuide(false);
    }

    // Additional logic as needed
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get('user');
      // console.log(response?.status);
      if (response?.status === 200) {
        setLoading(false);
        // console.log(response?.data);
        setUserData(response?.data);
        setShowGuide(!response?.data.guided);
        // Handle successful response, e.g., set some state.
      } else if (response?.data?.detail == 'Unauthenticated!') {
        setLoading(false);
        setUserData(false);
        navigate('/auth/login'); // Use navigate to redirect to the login page.
      } else {
        setUserData(false);
        setLoading(false);
        navigate('/auth/login'); // Use navigate to redirect to the login page.
      }
    } catch (error) {
      setLoading(false);
      setUserData(false);
      navigate('/auth/login'); // Handle errors and redirect to the login page.
      // TODO: handle errors
    }
  };


  useEffect(() => {
    fetchData(); // Call the async function within useEffect.
  }, []);





  // const [isSidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [uploadFileStatus, setUploadFileStatus] = useState(true);
  const navigate = useNavigate();

  // current user
  const currentUser = data[0];
  // current Summary data
  const currentSummary = summaryData[0];

  const handleLogout = () => {
    localStorage.removeItem('token');
    // Remove the user from the state
  };

  // show error removed item 
  const showWarning = (message) => {
    toast.warn(message, {
      autoClose: 5000, // Close after 5 seconds
    });
  };

  // show error removed item 
  const showError = (message) => {
    toast.error(message, {
      autoClose: 5000, // Close after 5 seconds
    });
  };


  // show success
  const showSuccess = (message) => {
    toast.success(message, {
      autoClose: 5000, // Close after 5 seconds
    });
  };

  // show info 
  const showInfo = (message) => {
    toast.success(message, {
      autoClose: 5000, // Close after 5 seconds
    });
  };


  // show success dialog 5seconds
  const showSuccesUploadFileStatus = () => {
    toast.success('파일 성공적으로 업로드되었습니다.', {
      autoClose: 5000 // Close after 5 seconds
    });
    // setUploadFileStatus(true);
    // setTimeout(() => {
    //   setUploadFileStatus(false);
    // }, 5000); // Display the message for 5 seconds
  };

  async function onLogout() {
    // setLoading(true)
    await logout()
    fetchData();
  }

  const showErrorMessage = (message) => {
    toast.error(message, {
      autoClose: 5000, // Close after 5 seconds
    });
  };

  const showWarningMessage = (message) => {
    toast.warn(message, {
      autoClose: 5000, // Close after 5 seconds
    });
  };

  const showChangedUserStateMessage = (message) => {
    toast.success(message, {
      autoClose: 5000, // Close after 5 seconds
    });
  }

  const handleClick = async () => {
    try {
      await axiosInstance.get('/guided'); // Update the endpoint as per your API
      setShowGuide(false); // Hide the guide
      window.open('https://www.miricanvas.com/v/12tyryo');
    } catch (error) {
      setShowGuide(false);
    }
  }

  // const toggleSidebar = () => {
  //   setSidebarCollapsed(!isSidebarCollapsed);
  // };

  return (
    <>
      <ToastContainer autoClose={5000} />

      {/* <!-- BEGIN #app --> */}
      <div id="app" className={`app app-footer-fixed app-content-full-width`} style={{ paddingTop: userData == false && 0, }} >

        {userData &&

          (<>
            {/* <!-- BEGIN #header --> */}
            {showGuide && (
              <Joyride
                continuous
                scrollToFirstStep
                showProgress
                showSkipButton
                steps={steps}
                spotlightClicks={true} // Allows interaction with the spotlighted element
                styles={{
                  options: {
                    zIndex: 10000,
                  },
                }}
                callback={handleJoyrideCallback}
              />
            )}
            <div id="header" class="app-header">
              {/* <!-- BEGIN desktop-toggler --> */}
              <div class="desktop-toggler">
                <span class="bar"></span>
                <span class="bar"></span>
              </div>
              {/* <!-- END desktop-toggler --> */}

              {/* <!-- BEGIN mobile-toggler --> */}
              <div class="mobile-toggler">
                <span class="bar"></span>
                <span class="bar"></span>
              </div>
              {/* <!-- END mobile-toggler --> */}

              {/* <!-- BEGIN brand --> */}
              <div class="brand" style={{ marginLeft: 25 }}>
                <a href="/" class="brand-logo"  >
                  <img src="/daewoong.png" width={'50%'} />
                  {/* <h5 style={{ marginLeft: 20 }}>ABM 회의록 통합 관리 시스템</h5> */}
                </a>
              </div>
              {/* <!-- END brand --> */}

              {/* <!-- BEGIN menu --> */}
              <div class="menu step1">
                <div class="menu-item">
                  <a onClick={handleClick} className="menu-link">
                    <i class="fa fa-info-circle fs-2 d-block text-body text-opacity-50"></i>
                  </a>
                  <a href="/" className="menu-link">
                    <i class="fa fa-home fs-2 d-block text-body text-opacity-50"></i>
                  </a>

                  <a onClick={() => setDropdown(!dropdown)} data-bs-toggle="dropdown" data-bs-display="static" class="menu-link" aria-expanded="false">
                    <div class="menu-img online">
                      <span class="menu-img-bg d-flex align-items-center jusFtify-content-center bg-secondary-subtle text-secondary rounded-circle overflow-hidden">
                        <img src={userData.image} />
                      </span>
                    </div>
                    <div class="menu-text d d-none">test@daewoong.co.kr</div>
                  </a>

                  <div class={`dropdown-menu dropdown-menu-end me-lg-3 mt-1 w-200px ${dropdown && 'show'}`} data-bs-popper="static">
                    <a class="dropdown-item d-flex align-items-center" href="/user"><i class="far fa-user fa-fw fa-lg me-3"></i> 마이페이지</a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item d-flex align-items-center" onClick={() => onLogout()}><i class="fa fa-arrow-right-from-bracket fa-fw fa-lg me-3"></i> Logout</a>
                  </div>
                </div>
              </div>
              {/* <!-- END menu --> */}

              {/* <!-- BEGIN menu-search --> */}
              <form class="menu-search" method="POST" name="header_search_form">
                <div class="menu-search-container">
                  <div class="menu-search-icon">
                    <i class="bi bi-search"></i>
                  </div>
                  <div class="menu-search-input">
                    <input
                      type="text"
                      class="form-control form-control-lg"
                      placeholder="Search menu..."
                    />
                  </div>
                  <div class="menu-search-icon">
                    <a
                      href="#"
                      data-toggle-class="app-header-menu-search-toggled"
                      data-toggle-target=".app"
                    >
                      <i class="bi bi-x-lg"></i>
                    </a>
                  </div>
                </div>
              </form>
              {/* <!-- END menu-search --> */}
            </div>
            {/* <!-- END #header --> */}
          </>)}




        {/* <!-- BEGIN #content --> */}
        <div id="content">
          <Routes>

            {
              userData && (<>
                <Route path='/'>
                  <Route path='/' element={<Summary closed={closed} setClosed={setClosed} showSuccess={showSuccess} showSuccessfullyDeleteSummary={showSuccess} showErrorDeleteSummary={showError} showWarning={showWarning} currentUserData={currentUser} />} />
                  <Route path='/summary/upload_audio' element={<UploadAudio showError={showError} showWarning={showWarning} showSuccess={showSuccess} />} />
                  <Route path='/draft-summary/:id' element={<DraftSummary showError={showError} showWarning={showWarning} showSuccess={showSuccess} />} />
                  <Route path='/user' element={<Home currentUserData={userData} />} />
                  <Route path='/guide' element={<Presentation />} />
                  {/* Catch-All Route */}
                  <Route path="*" element={<ErrorPage />} />
                  <Route path="/404" element={<ErrorPage />} />
                </Route>
              </>)}

            <Route path='/summary/upload_ppt_audio' element={<Upload showError={showError} showWarning={showWarning} showSuccess={showSuccess} />} />
            {userData != null && (
              <>
                <Route path='/auth'>
                  <Route path='login' element={userData == false ? <Login showError={showError} showWarning={showWarning} showSuccess={showSuccess} /> : <Navigate to='/' />} />
                  <Route path='register' element={userData == false ? <Register showError={showError} showWarning={showWarning} showSuccess={showSuccess} /> : <Navigate to='/' />} />
                  <Route path='bearworld' element={<Bearworld />} />
                  {/* Catch-All Route */}
                  <Route path="*" element={<ErrorPage />} />
                </Route>
              </>)
            }

          </Routes>

        </div >
        {/* <!-- END #content --> */}

        {/* <!-- BEGIN btn-scroll-top --> */}
        <a href="#" data-toggle="scroll-to-top" class="btn-scroll-top fade">
          <i class="fa fa-arrow-up"></i>
        </a>
        {/* <!-- END btn-scroll-top --> */}
      </div >
      <div id="footer" class="app-footer" style={{ marginLeft: '2rem' }}>
        © 2023-{new Date().getFullYear()} Daewoong | AI회의록 시스템
      </div>
      <a href="#" data-toggle="scroll-to-top" class="btn-scroll-top fade show"><i class="fa fa-arrow-up"></i></a>
      {/* <!-- END #app --> */}
    </>
  );
}

export default App;
